module.exports = __webpack_public_path__ + "img/rate_thankam.178663c2.jpg";